import { IQueryMediator } from 'core-ts-types';
import { TimeOccurrenceDataSource } from '../datastore/time/time_datasource';
import { ITimeOccurrenceDatatype } from '../datastore/time/data_types';

// Given built TimeOccurrence data, add it to data source.
function addBuiltTimeCommandDefinition(
  defineCommand: any,
  ngTimeOccurrenceDataSource: TimeOccurrenceDataSource,
  QueryMediator: IQueryMediator
) {
  return defineCommand(
    'addBuiltTimeCommand',
    function addBuiltTimeCommand(deferred: any, timeOccurrence: ITimeOccurrenceDatatype, index: number) {
      ngTimeOccurrenceDataSource.addTime(timeOccurrence, index);
      QueryMediator.runQueries(ngTimeOccurrenceDataSource);
      deferred.resolve(timeOccurrence);
    }
  );
}

angular.module('ui-ng-calendar').factory('addBuiltTimeCommand', addBuiltTimeCommandDefinition);



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/commands/add_built_time.ts